import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Typography,
  Box,
} from "@mui/material";
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import CloseIcon from "@mui/icons-material/Close";
import {
  button_bg_color_for_New_Project,
  settingsModal_bg_color_dm,
  uploadFiles_button_default_bg_color,
  uploadFiles_button_hovered_bg_color,
} from "../../../constants/colors";
import CommonToast from "../../Common_Components/CommonToast";
import gptlogosecond from "../../../assets/LLM_Modal_Logo/chatgpt-logo-png.png";
import cludelogosecond from "../../../assets/LLM_Modal_Logo/clude_Logo.png";

const ModalForSelectLLMModal = ({ showLLMModal, setShowLLMModal, selectedModalLabel, setSelectedModalLabel }) => {
  const { setSelectedLLMModal, selectedLLMModal } = useWorkspace();

  const [selectedModal, setSelectedModal] = useState("gpt-4o");
  const [selectedModalLabelLocal, setSelectedModalLabelLocal] = useState("GPT-4O");
  const [llmModalSaved, setLLMModalSaved] = useState(false);

  // const modals = [
  //   {
  //     label: "GPT-5",
  //     value: "gpt-5",
  //     title1: "OpenAI's flagship model for complex tasks",
  //     src: gptlogosecond,
  //   },
  //   {
  //     label: "GPT-4O",
  //     value: "gpt-4o",
  //     title1: "OpenAI's multimodal flagship (text, image, audio)",
  //     src: gptlogosecond,
  //   },
  //   {
  //     label: "GPT-4O Mini",
  //     value: "gpt-4o-mini",
  //     title1: "Lightweight, faster, and cheaper multimodal variant",
  //     src: gptlogosecond,
  //   },
  //   {
  //     label: "GPT-4.1",
  //     value: "gpt-4.1",
  //     title1: "Improved GPT-4 variant with enhanced reasoning",
  //     src: gptlogosecond,
  //   },
  //   {
  //     label: "GPT-4.1 Mini",
  //     value: "gpt-4.1-mini",
  //     title1: "Cheaper, smaller GPT-4.1 model for everyday tasks",
  //     src: gptlogosecond,
  //   },
  //   {
  //     label: "GPT-3.5 Turbo",
  //     value: "gpt-3.5-turbo",
  //     title1: "Fast and cost-effective option for simpler tasks",
  //     src: gptlogosecond,
  //   },
  // ];


  const modals = [
  { label: "GPT-4O", value: "gpt-4o", title1: "OpenAI’s flagship multimodal model", src: gptlogosecond },
  { label: "GPT-4O Mini", value: "gpt-4o-mini", title1: "Faster, cheaper multimodal GPT-4O", src: gptlogosecond },
  { label: "GPT-4 Turbo", value: "gpt-4-turbo", title1: "Efficient GPT-4 variant for reasoning tasks", src: gptlogosecond },
  { label: "GPT-4", value: "gpt-4", title1: "OpenAI’s GPT-4 for advanced reasoning", src: gptlogosecond },
  { label: "GPT-3.5 Turbo", value: "gpt-3.5-turbo", title1: "Fast, cost-effective GPT-3.5", src: gptlogosecond },
  { label: "GPT-3.5 Turbo (1106)", value: "gpt-3.5-turbo-1106", title1: "GPT-3.5 tuned variant", src: gptlogosecond },
  { label: "Claude Opus 4.1", value: "claude-opus-4-1-20250805", title1: "Anthropic’s most advanced reasoning model", src: cludelogosecond },
  { label: "Claude Opus 4", value: "claude-opus-4-20250514", title1: "Claude Opus 4 for complex reasoning", src: cludelogosecond },
  { label: "Claude Sonnet 4", value: "claude-sonnet-4-20250514", title1: "Balanced Claude model for everyday tasks", src: cludelogosecond },
  { label: "Claude 3.7 Sonnet", value: "claude-3-7-sonnet-20250219", title1: "Claude 3.7 Sonnet with strong reasoning", src: cludelogosecond },
  { label: "Claude 3.5 Sonnet", value: "claude-3-5-sonnet-20241022", title1: "Claude 3.5 Sonnet, balanced performance", src: cludelogosecond },
];


  const theme = localStorage.getItem("theme");

  const handleClose = () => {
    setShowLLMModal(false);
    setSelectedModal(selectedLLMModal);
    setSelectedModalLabelLocal(selectedModalLabel)
  };

  const handleSave = () => {
    setSelectedLLMModal(selectedModal);
    setShowLLMModal(false);
    setSelectedModalLabel(selectedModalLabelLocal)
  };

  const handleSelectModal = (modal) => {
    setSelectedModal(modal?.value);
    setSelectedModalLabelLocal(modal.label)
  };

  const handleCloseToast = () => {
    setLLMModalSaved(false);
  };

  return (
    <>
      <CommonToast
        open={llmModalSaved}
        onClose={handleCloseToast}
        content="AI Modal saved"
        bgColor="#282D51"
        fontColor="#fff"
        fontSize="14px"
        fontWeight="500"
        autoHideDuration={3000}
        iconType="success"
      />
      <Dialog
        open={showLLMModal}
        onClose={handleClose}
        maxWidth="md" // increase maxWidth
        PaperProps={{
          style: {
            width: "auto", // Fixed width
            height: "636px", // Fixed height
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor:
              theme === "dark" ? settingsModal_bg_color_dm : "#fff",
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: theme === "dark" ? "#FFFFFF" : "",
            position: "relative",
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
          }}
        >
          Select AI Modal
          <span
            style={{
              content: '""',
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              height: "1px",
              backgroundColor: "#FFFFFF",
              opacity: 0.2, // Set the opacity for the border
            }}
          ></span>
          <Box
            onClick={handleClose}
            sx={{
              cursor: "pointer",
            }}
          >
            <CloseIcon />
          </Box>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            alignSelf: "center",
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
            backgroundColor: theme === "light" ? "#dee2e6" : "",
            p: 2,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <FormControl component="fieldset">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "28px", // Space between items,
                justifyContent: "center",
              }}
            >
              {modals.map((modal, index) => (
                <div key={index}>
                  <div
                    onClick={() => handleSelectModal(modal)}
                    style={{
                      // marginBottom: '12px',
                      textAlign: "center",
                      cursor: "pointer",
                      border:
                        selectedModal === modal?.value
                          ? "1px solid #ffffff"
                          : "none",
                      borderRadius: "10px",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      columnGap: "10px",
                    }}
                  >
                    <img
                      src={modal?.src}
                      alt={modal?.label}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "7px",
                      }}
                    />

                    <div
                      style={{
                        textAlign: "start",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                      }}
                    >
                      <Typography variant="body1" sx={{ color: "#FFFFFF" }}>
                        {modal?.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#FFFFFF",
                          marginBottom: "-12px",
                        }}
                      >
                        {modal.title1}
                      </Typography>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              mt: 2,
              pt: 2,
              position: "relative",
              width: "100%",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "1px",
                backgroundColor: theme === "dark" ? "#FFFFFF" : "#ccc",
                opacity: 0.2, // Set the opacity for the border
              },
            }}
          >
            <Button
              onClick={handleClose}
              sx={{
                mr: 1,
                backgroundColor:
                  theme === "dark" ? uploadFiles_button_default_bg_color : "",
                "&:hover": {
                  backgroundColor: uploadFiles_button_hovered_bg_color,
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor:
                  theme === "dark" ? button_bg_color_for_New_Project : "",
                "&:hover": {
                  backgroundColor: "#FFD9AA",
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
              }}
            >
              Save
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalForSelectLLMModal;
